import { HttpClient } from "@/service/httpClient";
import { formatDate, formatLocalDate, formatTime } from "@/utils/util";

export const reservationDisabledHours = [0, 1, 2, 3, 4, 5, 6, 7, 22, 23];
export const getStartDate = (openDateString: string) => {
  const today = new Date();
  const startDate = new Date(new Date().setDate(today.getDate() + 2));
  if (openDateString && openDateString.length) {
    const openDate = new Date(`${openDateString} GMT+8`);
    if (openDate && openDate > startDate) {
      return openDate;
    }
  }
  return startDate;
};

export const getStartDateRange = (startDate: Date, skipSunday?: boolean) => {
  return [...Array(14)]
    .map(
      (_, i) => new Date(new Date(startDate).setDate(startDate.getDate() + i))
    )
    .filter(date => !skipSunday || date.getDay() !== 0)
    .map(date => {
      return {
        rawDate: date,
        key: formatDate(date),
        title: formatLocalDate(date)
      };
    });
};

export const timeRangeList = (
  start: number,
  end: number,
  step: number,
  maxEndmin: number
) => {
  const result = [];
  while (start < end) {
    for (let i = 0; i < 60; i += step) {
      if (start === end - 1 && i > maxEndmin) {
        break;
      }
      result.push(
        `${start.toString().padStart(2, "0")}:${i.toString().padStart(2, "0")}`
      );
    }
    start++;
  }
  return result;
};

export const reservationFullTime = (
  courseId: string,
  startDate: number,
  endDate: number
) => {
  return HttpClient.get<any[]>(
    `reservation/reservationFullTime?courseId=${courseId}&startDate=${startDate}&endDate=${endDate}`
  ).then(({ data }) => {
    return data.reduce((result: any, timeStamp: number) => {
      const obbject = new Date(timeStamp);
      const date = formatDate(obbject);
      const time = formatTime(obbject);

      let map = result[date];
      if (!map) {
        map = {};
        result[date] = map;
      }
      map[time] = true;
      return result;
    }, {});
  });
};
